var _defs, _rect, _g, _g2, _g3, _g4, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaBackup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    viewBox: "0 0 600 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mbBg",
    x1: 0,
    y1: 0,
    x2: 600,
    y2: 400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0175C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mbScreen",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0c1730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#132649"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#mbBg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 60,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 40,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 300,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 330,
    r: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 60 a34 34 0 0 1 66 -10 a26 26 0 0 1 8 51 H36 a24 24 0 0 1 4 -41 Z",
    fill: "#ffffff",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 78 v34 M74 78 l-14 14 M74 78 l14 14",
    stroke: "#0175C2",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 150,
    height: 240,
    rx: 22,
    fill: "#0b1220"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 130,
    height: 220,
    rx: 14,
    fill: "url(#mbScreen)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 28,
    width: 46,
    height: 46,
    rx: 6,
    fill: "#00ADD8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 28,
    width: 46,
    height: 46,
    rx: 6,
    fill: "#4dd0e1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 84,
    width: 46,
    height: 46,
    rx: 6,
    fill: "#5c6bc0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 84,
    width: 46,
    height: 46,
    rx: 6,
    fill: "#26c6da"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 140,
    width: 46,
    height: 46,
    rx: 6,
    fill: "#42a5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 140,
    width: 46,
    height: 46,
    rx: 6,
    fill: "#00ADD8"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 45,
    r: 8,
    fill: "#ffe082"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 196,
    width: 102,
    height: 10,
    rx: 5,
    fill: "#26374d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 222,
    r: 7,
    fill: "#26374d"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeWidth: 6,
    strokeLinecap: "round",
    opacity: 0.9,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290 210 q60 -30 110 -70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 150 l18 -10 l2 20"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 378,
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700,
    fill: "#ffffff"
  }, "Self-Hosted Media Backup")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaBackup);
export default __webpack_public_path__ + "static/media/media-backup.b721c0d2c029fc5a7d22679c907040a1.svg";
export { ForwardRef as ReactComponent };